export enum SurveyAndOpinionPollRequestTypeEnum {
  Field_Survey = 'Field_Survey',
  Opinion_Poll = 'Opinion_Poll'
}
